import { fg } from '@atlassian/jira-feature-gating';

export default {
	get(): boolean {
		return fg('blu-6314-drag-and-drop-projects-sidebar-mouse');
	},
};
